module.exports = __webpack_public_path__ + "media/apps/mitch-ios-1-45924d85.png";